import {
  CATALOG_SECTORS,
  isCatalogSector,
  type CatalogSector,
} from "./sector-catalog";

/** Business sectors driven by `src/data/*.json` (no Other / Legal). */
export const BUSINESS_SECTORS = CATALOG_SECTORS;

export type BusinessSector = CatalogSector;

export function isBusinessSector(value: string): value is BusinessSector {
  return isCatalogSector(value);
}

export function listBusinessSectors(): readonly BusinessSector[] {
  return BUSINESS_SECTORS;
}
